export const formatRoleName = roleName => {
  if(roleName) {
    // const formattedName = roleName.replace(/[A-Z]/g, ' $&').trim()
    return roleName.trim()
  }
  return roleName
}
